import { disableAnalytics, calendlySchedulingUrl } from '@config';
import { experiment, FeatureFlagKeys } from '@lib/experiment';

import { loadCalendlyScheduler, type SchedulerUser } from './calendly';
import { loadQualifiedDocsChat } from './qualified';

/**
 * Loads the sales/product-specialist scheduling widget, choosing between
 * Calendly (new) and Qualified (legacy).
 *
 * Calendly is used only when the `enableCalendlyScheduler` flag is on AND a
 * scheduling link is configured (`REACT_APP_CALENDLY_SCHEDULING_URL`); otherwise
 * we fall back to Qualified so the "Contact sales" CTAs keep working.
 *
 * Must be called once feature flags are ready (i.e. after `experiment.identify`
 * resolves) — Flagsmith returns flag defaults until then. Both loaders guard
 * against double-loading, so repeated calls are safe.
 */
export const loadSchedulerWidget = (user: SchedulerUser = {}) => {
  if (disableAnalytics) {
    return;
  }

  const calendlyFlagEnabled = experiment.isFeatureEnabled(FeatureFlagKeys.enableCalendlyScheduler);

  if (calendlyFlagEnabled && calendlySchedulingUrl) {
    loadCalendlyScheduler(user);
    return;
  }

  if (calendlyFlagEnabled) {
    // eslint-disable-next-line no-console
    console.warn(
      '[scheduler] Calendly flag is on but REACT_APP_CALENDLY_SCHEDULING_URL is unset; falling back to Qualified.',
    );
  }

  loadQualifiedDocsChat();
};
